import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Composant LoadingSpinner
 * Affiche un spinner animé avec un message optionnel
 */
const LoadingSpinner = ({ message, fullScreen = false }) => {
  const { t } = useTranslation();

  const content = (
    <div className="text-center">
    <div className="h-16 shrink-0 "/>
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-bleu1 mx-auto"></div>
      {/* <p className="mt-4 text-gray-600">{message || t('common.loading')}</p> */}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
